import { CheckBox } from './CheckBox'
import { CustomInput, FormGroup, Label } from 'reactstrap'

export interface CheckBoxOption {
  id: number
  name: string
}

export interface CheckBoxGroupProps {
  options: CheckBoxOption[]
  selectedValues: number[]
  onChange: (values: number[]) => void
  disabled?: boolean
  id?: string
  size?: 'sm' | 'lg'
  label?: string
}

export const CheckBoxGroup: React.FC<CheckBoxGroupProps> = ({
  options,
  selectedValues,
  onChange,
  id = 'supplier',
  size,
  label,
  disabled = false,
}) => {
  const handleCheckboxChange = (optionId: number, isChecked: boolean) => {
    if (isChecked) {
      onChange([...selectedValues, optionId])
    } else {
      onChange(selectedValues.filter((id) => id !== optionId))
    }
  }

  return (
    <div>
      <Label for={id} size={size} css={{ padding: 0 }}>
        {label}
      </Label>

      <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
        {options.map((option) => (
          <CheckBox
            key={option.id}
            id={`checkbox-${option.id}`}
            label={option.name}
            checked={selectedValues.includes(option.id)}
            disabled={disabled}
            onChange={(isChecked) => handleCheckboxChange(option.id, isChecked)}
          />
        ))}
      </div>
    </div>
  )
}
